import React, {useEffect, useState} from 'react';
import {Link} from "react-router-dom";
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {Divider} from "@mui/material";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import DashboardIcon from '@mui/icons-material/Dashboard';
import {getUserInfo} from "../api/Api";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
import EventNoteIcon from "@mui/icons-material/EventNote";
import SupportIcon from "@mui/icons-material/Support";
import LogoutIcon from "@mui/icons-material/Logout";
import Aside from "layout/Aside";

const Header = () => {
    const [activeItem, setActiveItem] = useState([true, false, false, false]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [fName, setFName] = useState(null);
    const [lName, setLName] = useState(null);
    const [email, setEmail] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const open = Boolean(anchorEl);
    let path = window.location.pathname;
    useEffect(() => {
        if (path === '/' || path === '/edit-profile' || path === '/change-password') {
            setActiveItem(() => [
                true, false, false, false
            ]);

        }
        if (path === '/tickets' || path === '/tickets/ticket-detail' || path === '/tickets/add-ticket') {
            setActiveItem(() => [
                false, false, false, true
            ]);
        }
        if (path === '/factors' || path === '/factors/factor-detail') {
            setActiveItem(() => [
                false, false, true, false
            ]);
        }
        if (path === '/services/server-iran' || path === '/server-europe' ||
            path === '/card' ||
            path === '/services' || path === '/services/service-detail' ||
            path === '/services/server-europe/server-order' || path === '/services/server-iran/server-order') {
            setActiveItem(() => [
                false, true, false, false
            ]);
        }

        setLoading(true);
        let user_info = localStorage.getItem("user_info");
        if (user_info) {
            user_info = JSON.parse(user_info);
            setFName(user_info.first_name);
            setLName(user_info.last_name);
            setEmail(user_info.email);
        } else {
            setFName("");
            setLName("");
            setEmail("");
        }

    }, [path]);
    const logOut = () => {
        document.cookie = `is_login=false; path=/; domain=.zaminhost.com`;
        localStorage.removeItem("token");
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const parentDiv1 = React.useRef();
    const parentDiv2 = React.useRef();
    const [isActive1, setActive1] = useState("false");
    const [isActive2, setActive2] = useState("false");
    const [top, setTop] = useState(0);
    const [card, setCard] = useState(false);
    const ToggleClass1 = (e) => {
        setTop(e.clientX);
        // console.log(e.clientX)
        setActive1(!isActive1);
    };
    const ToggleClass2 = (e) => {
        setTop(e.clientX);
        // console.log(e.clientX)
        setActive2(!isActive2);
    };
    const myComponentStyle = {
        position: 'fixed',
        zIndex: 10,
        inset: '0px 0px auto auto',
        margin: 0,
        width: '200px',
        transform: 'translate(' + -113 + 'px, ' + top + 'px)'
    }
    const [state, setState] = React.useState({
        right: false,
    });

    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event &&
            event.type === 'keydown' &&
            (event.key === 'Tab' || event.key === 'Shift')
        ) {
            return;
        }

        setState({...state, [anchor]: open});
    };
    useEffect(() => {
        let product_store = JSON.parse(localStorage.getItem("product"));
        let valid_store = JSON.parse(localStorage.getItem("validList"));
        let attr_store = JSON.parse(localStorage.getItem("attrList"));
        let sum_store = JSON.parse(localStorage.getItem("sum"));
        if (product_store && valid_store && attr_store && sum_store) {
            setCard(true);
        }
    })
    return (
        <React.Fragment>
            <div id="kt_header" className="header align-items-stretch">
                <div className="container-fluid d-flex align-items-stretch justify-content-between">
                    <div className="d-flex align-items-center d-lg-none ms-n1 me-2" title="Show aside menu">
                        <Button onClick={toggleDrawer("right", true)}>
                            <span className="svg-icon svg-icon-1" style={{transform: "rotate(180deg)"}}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                     viewBox="0 0 24 24" fill="none">
                                    <path
                                        d="M13 11H3C2.4 11 2 10.6 2 10V9C2 8.4 2.4 8 3 8H13C13.6 8 14 8.4 14 9V10C14 10.6 13.6 11 13 11ZM22 5V4C22 3.4 21.6 3 21 3H3C2.4 3 2 3.4 2 4V5C2 5.6 2.4 6 3 6H21C21.6 6 22 5.6 22 5Z"
                                        fill="black"/>
                                    <path opacity="0.3"
                                          d="M21 16H3C2.4 16 2 15.6 2 15V14C2 13.4 2.4 13 3 13H21C21.6 13 22 13.4 22 14V15C22 15.6 21.6 16 21 16ZM14 20V19C14 18.4 13.6 18 13 18H3C2.4 18 2 18.4 2 19V20C2 20.6 2.4 21 3 21H13C13.6 21 14 20.6 14 20Z"
                                          fill="black"/>
								</svg>
							</span>
                        </Button>
                        <SwipeableDrawer
                            anchor={"right"}
                            open={state["right"]}
                            onClose={toggleDrawer("right", false)}
                            onOpen={toggleDrawer("right", true)}
                        >
                            {/*testr*/}
                            <Aside />
                        </SwipeableDrawer>
                    </div>
                    <div className="d-flex align-items-stretch justify-content-between flex-lg-grow-1">
                        <div className="d-flex align-items-stretch" id="kt_header_nav">
                            <div className="header-menu align-items-stretch" data-kt-drawer="true"
                                 data-kt-drawer-name="header-menu"
                                 data-kt-drawer-activate="{default: true, lg: false}"
                                 data-kt-drawer-overlay="true"
                                 data-kt-drawer-width="{default:'200px', '300px': '250px'}"
                                 data-kt-drawer-direction="end"
                                 data-kt-drawer-toggle="#kt_header_menu_mobile_toggle"
                                 data-kt-swapper="true" data-kt-swapper-mode="prepend"
                                 data-kt-swapper-parent="{default: '#kt_body', lg: '#kt_header_nav'}">
                                <div
                                    className="menu menu-lg-rounded menu-column menu-lg-row menu-state-bg menu-title-gray-700 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-400 fw-bold my-5 my-lg-0 align-items-stretch"
                                    id="#kt_header_menu" data-kt-menu="true">
                                    <Link to={{pathname: "https://zaminhost.com"}} data-kt-menu-trigger="click"
                                          target="_blank" data-kt-menu-placement="bottom-end"
                                          className="menu-item menu-lg-down-accordion me-lg-1">
												<span className="menu-link py-3">
													<span className="menu-title">صفحه اصلی</span>
													<span className="menu-arrow d-lg-none"/>
												</span>
                                    </Link>
                                    <Link to={{pathname: "https://zaminhost.com/site/about"}} target="_blank"
                                          data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end"
                                          className="menu-item menu-lg-down-accordion me-lg-1">
												<span className="menu-link py-3">
													<span className="menu-title">درباره ما</span>
													<span className="menu-arrow d-lg-none"/>
												</span>
                                    </Link>
                                    <Link to={{pathname: "https://zaminhost.com/blog"}} target="_blank"
                                          data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end"
                                          className="menu-item menu-lg-down-accordion me-lg-1">
												<span className="menu-link py-3">
													<span className="menu-title">بلاگ</span>
													<span className="menu-arrow d-lg-none"/>
												</span>
                                    </Link>
                                    <Link to={{pathname: "https://zaminhost.com/site/contact"}} target="_blank"
                                          data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end"
                                          className="menu-item menu-lg-down-accordion me-lg-1">
												<span className="menu-link py-3">
													<span className="menu-title">تماس با ما</span>
													<span className="menu-arrow d-lg-none"/>
												</span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-items-stretch flex-shrink-0">

                            <div className="d-flex align-items-center ms-1 ms-lg-3">
                                <Link to={"/card"
                                } title="سبد خرید" data-bs-toggle="tooltip"
                                      data-bs-trigger="hover" data-bs-dismiss="click" data-bs-placement="bottom"
                                      className="btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px pulse pulse-success"
                                      id="kt_activities_toggle">
                                    <i className="bi bi-cart2 fs-1"/>
                                    {
                                        card &&
                                        <span className="pulse-ring w-45px h-45px"/>
                                    }
                                </Link>
                            </div>
                            <div
                                className={"btn btn-icon btn-active-light-primary d-flex align-items-center align-self-center ms-1 ms-lg-3"}>
                                <div
                                    id="basic-button"
                                    title="پروفایل" data-bs-toggle="tooltip"
                                    data-bs-trigger="hover" data-bs-dismiss="click" data-bs-placement="bottom"
                                    aria-controls={open ? 'basic-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={open ? 'true' : undefined}
                                    onClick={handleClick}
                                    className={"cursor-pointer symbol symbol-30px symbol-md-40px"}
                                >
                                    <i className="bi bi-person-bounding-box fs-1"/>
                                </div>
                            </div>

                            <div
                                className="btn btn-icon btn-active-light-primary d-flex align-items-center align-self-center ms-1 ms-lg-3">
                                <a href="" type="button"
                                   className="btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px pulse pulse-success"
                                   onClick={() => localStorage.removeItem("token")}
                                   data-kt-menu-trigger="click" data-kt-menu-overflow="true"
                                   data-kt-menu-placement="top-start" data-bs-toggle="tooltip"
                                   data-bs-placement="right" data-bs-dismiss="click" title="خروج">
                                    <i className="bi bi-box-arrow-left fs-1"/>
                                </a>
                            </div>
                            <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                MenuListProps={{
                                    'aria-labelledby': 'basic-button',
                                }}
                            >
                                <MenuItem onClick={handleClose}>
                                    <div className="menu-content d-flex align-items-center px-3">

                                        <div className="symbol symbol-50px me-5">
                                            <i className="bi bi-person-bounding-box fs-1"/>
                                        </div>
                                        <div className="d-flex flex-column">
                                            <div
                                                className="fw-bolder d-flex align-items-center fs-7 yekan-font">{fName + " " + lName}</div>
                                            <a href="#"
                                               className="fw-bold text-muted text-hover-primary fs-7">{email}</a>
                                        </div>
                                    </div>
                                </MenuItem>
                                <Divider style={{backgroundColor: "#eaeaea"}}/>
                                <MenuItem onClick={handleClose}>
                                    <Link to={"/edit-profile"} className="menu-link px-5 yekan-font">ویرایش اطلاعات
                                        کاربری</Link>
                                </MenuItem>
                                <MenuItem onClick={handleClose}>
                                    <Link to={"/permission/access-group"} className="menu-link px-5 yekan-font">گروه
                                        دسترسی</Link>
                                </MenuItem>
                                <MenuItem onClick={handleClose}>
                                    <Link to={"/change-password"} className="menu-link px-5 yekan-font">تغییر کلمه
                                        عبور</Link>
                                </MenuItem>
                            </Menu>
                            <div className="d-flex align-items-center flex-grow-1 flex-lg-grow-0">
                                <a className="d-lg-none d-flex align-items-center" href="https://zaminhost.com/">
                                    <img alt="Logo" src="./assets/media/logo-org.png" width={"40px"}
                                         className="logo"/>
                                </a>
                            </div>

                        </div>

                    </div>

                </div>

            </div>
        </React.Fragment>
    );
};

export default Header;